import type { FC } from 'react';
import { styled } from 'goober';

import type { FlexBoxProps } from '@/ui/flexbox/flexbox';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { SmallText } from '@/ui/typography/action-panel';

interface WithLabelProps extends FlexBoxProps {
  labelText: string;
  labelPosition?: 'top' | 'bottom';
  isRequired?: boolean;
}

/**  @deprecated replaced by FormLabel from components/form/FormLabel */
export const WithLabel: FC<WithLabelProps> = ({
  children,
  name,
  labelText,
  labelPosition = 'bottom',
  isRequired = false,
  ...props
}) => {
  const labelContent = (
    <Label>
      {labelText}
      {isRequired && <RequiredIndicator>*</RequiredIndicator>}
    </Label>
  );

  return (
    <Container name={name} direction="column" gap="6px" {...props}>
      {labelPosition === 'top' && labelContent}
      {children}
      {labelPosition === 'bottom' && labelContent}
    </Container>
  );
};

const Container = styled(Flexbox)`
  position: relative;
`;

const Label = styled(SmallText)`
  margin-left: 10px;
`;

const RequiredIndicator = styled('span')`
  color: ${({ theme }) => theme.colors.system.lowFit};
  margin-left: 2px;
`;
